// Smooth open/close for the product page's details sections (Olfactive Pyramid, Ingredients).
// The native <details> toggles instantly; this opens them like a drawer: the panel grows while
// the text slides down out from under the title.
(() => {
  if (window.productAccordionReady) return;
  window.productAccordionReady = true;

  // Even ease-in-out so the panel visibly travels the whole way, like a drawer being pulled
  const OPEN = { duration: 750, easing: 'cubic-bezier(0.45, 0, 0.2, 1)' };
  const CLOSE = { duration: 550, easing: 'cubic-bezier(0.45, 0, 0.25, 1)' };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element && event.target.closest('.product__accordion summary');
    if (!summary || reduced.matches) return;
    const details = summary.parentElement;
    const content = details.querySelector('.accordion__content');
    if (!content || details.dataset.animating) return;
    event.preventDefault();
    details.dataset.animating = 'true';

    const done = () => delete details.dataset.animating;
    const items = [...content.children];

    // The panel grows (clipped) while its text slides down out from under the title, so the text
    // travels with the opening edge instead of appearing in place
    const run = (opening) => {
      const height = content.offsetHeight;
      const timing = opening ? OPEN : CLOSE;
      // Animate the space under the text too; otherwise it vanishes in one step when the section
      // shuts and the next section jumps up
      const { marginTop, marginBottom } = getComputedStyle(content);
      const shut = { height: '0px', marginTop: '0px', marginBottom: '0px' };
      const full = { height: `${height}px`, marginTop, marginBottom };
      content.style.overflow = 'hidden';
      const panel = content.animate(opening ? [shut, full] : [full, shut], timing);
      const hidden = { transform: `translateY(-${height}px)`, opacity: 0.2 };
      const shown = { transform: 'translateY(0)', opacity: 1 };
      items.forEach((item) => item.animate(opening ? [hidden, shown] : [shown, hidden], timing));
      panel.onfinish = () => {
        if (!opening) details.open = false;
        content.style.overflow = '';
        done();
      };
    };

    if (details.open) {
      run(false);
    } else {
      details.open = true;
      run(true);
    }
  });
})();
